import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { trim } from '../../../utilities/trim.esm.js';
import { createAvailableOptionsStringMapSelector } from './available-options-string-map-selector.esm.js';

function mapAvailableOptions(stringMap, allFields) {
  if (!allFields) {
    return {};
  }
  return allFields.reduce(function (acc, item, order) {
    var label = typeof item.label === 'string' ? trim(item.label) : item.label;
    var id = stringMap.toString(item.id);
    if (id === undefined) {
      throw new Error("Cannot find column ".concat(item.id));
    }
    if (typeof label === 'string' && !label.length || !label) {
      return acc;
    }
    var longLabel = label;
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, id, {
      label: label,
      longLabel: longLabel,
      order: order,
      lock: !!item.lock
    }));
  }, {});
}
var createAvailableOptionsSelector = function createAvailableOptionsSelector() {
  var availableOptionsStringMapSelector = createAvailableOptionsStringMapSelector();
  return createSelector(availableOptionsStringMapSelector, function (props) {
    return props.allFields;
  }, mapAvailableOptions);
};

export { createAvailableOptionsSelector };
//# sourceMappingURL=available-options-selector.esm.js.map
